import { Routes } from '@angular/router';
import { EditGroupeDiffusionComponent } from './edit-groupe-diffusion/edit-groupe-diffusion.component';
import { ListeGroupesDiffusionComponent } from './liste-groupes-diffusion/liste-groupes-diffusion.component';

export const GROUPES_DIFFUSION_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const GROUPES_DIFFUSION_ROUTES: Routes = [
    { path: '', component: ListeGroupesDiffusionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditGroupeDiffusionComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditGroupeDiffusionComponent, data: { roles: ['ORGANISME'] } }
];
